import ImageResize from 'image-resize'

export default async function compressImage (imageObject, imageName, fileType) {
    const imageResize = new ImageResize({
        format: fileType === 'jpeg' ? 'jpg' : fileType,
        quality: 1,
        width: 400,
        height: 400,
    })
    const resizedImageBase64 = await imageResize.play(imageObject)
    const resizedImageBlob = await fetch(resizedImageBase64).then(r => r.blob())
    return blobToFile(resizedImageBlob, imageName)
}

export function blobToFile (imageBlob, fileName) {
    imageBlob.lastModifiedDate = new Date()
    imageBlob.name = fileName
    return imageBlob
}
